import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(VApp,[_c('Header'),_c(VContent,[_c('router-view')],1),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }